import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ColorConfig, ColorConfigJson} from './color-config';
import {MeasureTypePressureConfig, MeasureTypePressureConfigJson} from './measure-type-pressure-config';

export type PressureThresholdConfigJson = {
  value: MeasureTypePressureConfigJson;
  color: ColorConfigJson;
};

export class PressureThresholdConfig implements JsonConfigInterface<PressureThresholdConfigJson> {

  public readonly value: MeasureTypePressureConfig = new MeasureTypePressureConfig();
  public readonly color: ColorConfig = new ColorConfig();

  constructor(json?: PressureThresholdConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public deserializeJson(json: PressureThresholdConfigJson): void {
    this.value.deserializeJson(json.value);
    this.color.deserializeJson(json.color);
  }
}
